import React, { useCallback, useContext, useRef, useState } from 'react'
import { Col, Row, Card, Form, InputGroup, Container, Button, Spinner } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faFileExcel } from '@fortawesome/free-solid-svg-icons'
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { useCookies } from 'react-cookie'
import { Context } from '../RefundHistory'
import { exportAllRefund } from '../../../../../controller/api/refund'
import { exportRefundHistoryToExcel } from '../../../../../helpers/excelExport'

const REFUND_END_POINT_ID = 'APP'
const REFUND_SOURCE_LABEL = 'Ứng dụng'

const _FilterForm = () => {

  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(['lottmekong']);

  const [isExporting, setIsExporting] = useState(false);

  const _from = useRef(state.filter.from);
  const _to = useRef(state.filter.to);
  const _phone = useRef(state.filter.phone);

  const _handleChangeFrom = useCallback((payload) => {
    _from.current = payload
  }, [])

  const _handleChangeTo = useCallback((payload) => {
    _to.current = payload
  }, [])

  const _handleChangePhone = useCallback((payload) => {
    _phone.current = payload.target.value
  }, [])

  const _submitForm = useCallback(() => {
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        from: _from.current,
        to: _to.current,
        phone: _phone.current
      }
    })
  }, [dispatch])

  const handleExportExcel = async () => {
    setIsExporting(true)
    try {
      const response = await exportAllRefund(cookies.lottmekong, {
        from: state.filter.from,
        to: state.filter.to,
        phone: state.filter.phone
      }, REFUND_END_POINT_ID)

      if (response && response.data) {
        exportRefundHistoryToExcel(response.data, state.filter, REFUND_SOURCE_LABEL)
      }
    } catch (error) {
      console.error('Export failed:', error)
      alert('Xuất Excel thất bại. Vui lòng thử lại!')
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col className='align-self-center'>
              <h5>LỊCH SỬ THU HỒI APP</h5>
            </Col>
            <Col className='text-right'>
              <Button style={{ marginRight: 20 }} variant="info" type="submit" onClick={_submitForm}>Tìm kiếm</Button>
              <Button
                style={{ marginRight: 20 }}
                variant="success"
                type="button"
                disabled={isExporting}
                onClick={handleExportExcel}
              >
                {isExporting ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Đang xuất...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                    Xuất Excel
                  </>
                )}
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Container>
            <Col>
              <Row className='p-1'>
                <Col>
                  <Row>
                    <Col md={3} className='text-right align-self-center'>
                      <Form.Label>Từ ngày</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Datetime
                        timeFormat={false}
                        onChange={_handleChangeFrom}
                        renderInput={(props, openCalendar) => (
                          <InputGroup>
                            <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                            <Form.Control
                              required
                              type="text"
                              value={_from.current ? moment(_from.current).format("DD/MM/YYYY") : ""}
                              placeholder="dd/mm/yyyy"
                              onFocus={openCalendar}
                              onChange={() => { }} />
                          </InputGroup>
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row>
                    <Col md={3} className='text-right align-self-center'>
                      <Form.Label>Đến ngày</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Datetime
                        timeFormat={false}
                        onChange={_handleChangeTo}
                        renderInput={(props, openCalendar) => (
                          <InputGroup>
                            <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                            <Form.Control
                              required
                              type="text"
                              value={_to.current ? moment(_to.current).format("DD/MM/YYYY") : ""}
                              placeholder="dd/mm/yyyy"
                              onFocus={openCalendar}
                              onChange={() => { }} />
                          </InputGroup>
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className='p-1'>
                <Col>
                  <Row>
                    <Col md={3} className='text-right align-self-center'>
                      <Form.Label>Số điện thoại</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Control onChange={_handleChangePhone} required type="text" placeholder="Nhập số điện thoại (Để trống để tìm tất cả)" />
                    </Col>
                  </Row>
                </Col>
                <Col>
                </Col>
              </Row>
            </Col>
          </Container>
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_FilterForm)